const KEY = "nodeUserCache";
// A hard refresh within this window skips the /inituser round trips and
// reuses the cached profile. MSAL still enforces authentication on every
// protected route, so this only short-circuits our own profile fetches.
const MAX_AGE_MS = 15 * 60 * 1000;

export function cacheUser(user) {
  try {
    sessionStorage.setItem(KEY, JSON.stringify({ user, ts: Date.now() }));
  } catch {
    // Storage full/disabled — worst case we just re-init next refresh.
  }
}

export function readCachedUser() {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    const { user, ts } = JSON.parse(raw);
    if (!user || !ts || Date.now() - ts > MAX_AGE_MS) return null;
    return user;
  } catch {
    return null;
  }
}

export function clearCachedUser() {
  try {
    sessionStorage.removeItem(KEY);
  } catch {}
}
